import { render, staticRenderFns } from "./Uninsist.vue?vue&type=template&id=678c998e&scoped=true"
import script from "./Uninsist.vue?vue&type=script&lang=ts"
export * from "./Uninsist.vue?vue&type=script&lang=ts"
import style0 from "./Uninsist.vue?vue&type=style&index=0&id=678c998e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c998e",
  null
  
)

export default component.exports